const isDev = () => !window.location.hostname.startsWith("www.");
var config_default = {
  isDev
};
export {
  config_default as default,
  isDev
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
